
export function cast_to_array(obj) {
  const keys = [];
  for (const key in obj) {
    for (const key2 in obj[key]) {
      keys.push(key2);
    }
  }
  return keys;
}

export function cast_to_formats(obj) {
  const keys = [];
  for (const key in obj) {
    for (const key_ in obj[key].formats) {
      keys.push(obj[key].formats[key_]);
    }
  }
  return keys;
}

export function get_img(fileName) {
  return './assets/ui/svg/blue/' + fileName.toLowerCase() + '-icon.svg';
}

export function get_formats(obj) {
  const keys = [];
  for (const key in obj.formats) {
    keys.push(key);
  }
  return keys;
}

export function cast_to_icons(obj) {
  const keys = [];
  for (const key in obj) {
    keys.push({
      title: obj[key].label,
      extension: obj[key].extension,
      img: get_img(obj[key].label),
      formats: get_formats(obj[key])
    });
  }
  return keys;
}

export function cast_to_extension(objs) {
  const keys = [];
  for (const obj in objs) {
    for (const key in objs[obj]) {
      keys.push('.' + objs[obj][key].toLowerCase());
    }
  }
  return keys.join(', ');
}


